import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TimelineEventVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveTimelineEvents } from "@academy-context/read/application/use-cases/admin/timeline-events-retrieval/retrieve-timeline-events";

const initialState: RetrievalState<TimelineEventVM[]> = { fetching: "idle", data: [] };

export const retrieveTimelineEventsReducer = createReducer<RetrievalState<TimelineEventVM[]>>(initialState, builder => {
  builder.addCase(retrieveTimelineEvents.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTimelineEvents.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTimelineEvents.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
